import "./KitchenRemodeling.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Inclusions from "./sections/Inclusions";
import CostTimeline from "./sections/CostTimeline";
import RequestEstimate from "./sections/RequestEstimate";
import KitchenFaq from "./sections/KitchenFaq";
import Estimate from "./sections/Estimate";
import RelatedGuides from "./sections/RelatedGuides";
import Footer from "@/reusable_sections/Footer";
export default function KitchenRemodelingPage() {
  return <div>
      <Header />
      <Hero />
      <Inclusions />
      <CostTimeline />
      <RequestEstimate />
      <KitchenFaq />
      <Estimate />
      <RelatedGuides />
      <Footer />
    </div>;
}